import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Settings, Briefcase, Send, Database, BarChart3, Key, LogOut, UserCog, FileText, Activity } from 'lucide-react';

export default function DashboardFuncionario() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuItems = [
    {
      icon: Settings,
      title: 'Gestión de Usuarios',
      description: 'Administrar usuarios del sistema',
      onClick: () => navigate('/gestion-usuarios')
    },
    {
      icon: Briefcase,
      title: 'Mis convocatorias',
      description: 'Ver y administrar convocatorias',
      onClick: () => navigate('/convocatorias')
    },
    {
      icon: FileText,
      title: 'Contratos y Resoluciones',
      description: 'Gestionar contratos y resoluciones',
      onClick: () => navigate('/contratos-resoluciones')
    },
    {
      icon: Send,
      title: 'Consultas postulaciones',
      description: 'Revisar y calificar postulaciones',
      onClick: () => navigate('/consulta-postulaciones')
    },
    {
      icon: Database,
      title: 'Usuarios Registrados',
      description: 'Listado de usuarios registrados',
      onClick: () => navigate('/usuarios-registrados')
    },
    {
      icon: BarChart3,
      title: 'Dashboard',
      description: 'Panel de estadísticas',
      onClick: () => navigate('/dashboard-estadisticas')
    },
    {
      icon: Activity,
      title: 'Logs de Actividad',
      description: 'Registro de eventos del sistema',
      onClick: () => navigate('/logs-actividad')
    },
    {
      icon: UserCog,
      title: 'Editar mi perfil',
      description: 'Actualizar información personal',
      onClick: () => navigate('/perfil/editar')
    },
    {
      icon: Key,
      title: 'Cambiar contraseña',
      description: 'Actualizar tu contraseña',
      onClick: () => navigate('/forgot-password')
    },
    {
      icon: LogOut,
      title: 'Salir',
      description: 'Cerrar sesión',
      onClick: handleLogout
    }
  ];

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      {/* Header */}
      <header className="bg-[#0F172A] border-b border-slate-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_login-verify-system/artifacts/gyieqwft_Captura%20de%20Pantalla%202025-12-10%20a%20la%28s%29%207.03.41%20a.%C2%A0m..png" 
              alt="Logo" 
              className="h-12 w-auto object-contain brightness-0 invert"
            />
            <div className="border-l border-slate-600 pl-4">
              <h1 className="text-xl font-semibold text-white">
                Panel Funcionario
              </h1>
              <p className="text-sm text-slate-300">
                {user?.first_name} {user?.first_lastname}
              </p>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="space-y-8">
          {/* Welcome Section */}
          <div className="bg-white rounded-lg p-8 shadow-sm border border-slate-200">
            <h2 className="text-3xl font-bold text-slate-900 mb-2">
              Bienvenido, {user?.first_name}
            </h2>
            <p className="text-lg text-slate-600">
              Gestiona y administra el sistema desde tu panel de control
            </p>
          </div>

          {/* Menu Grid */}
          <div className="grid grid-cols-1 gap-4">
            {menuItems.map((item, index) => {
              const Icon = item.icon;
              const isFirst = index === 0;
              const isLast = item.title === 'Salir';
              
              return (
                <button
                  key={index}
                  onClick={item.onClick}
                  className={`
                    w-full text-left p-6 rounded-lg border transition-all hover:shadow-md
                    ${isFirst 
                      ? 'bg-blue-50 border-blue-300 hover:bg-blue-100 hover:border-blue-400' 
                      : isLast
                      ? 'bg-white border-slate-200 hover:bg-slate-50'
                      : 'bg-white border-slate-200 hover:bg-slate-50'
                    }
                  `}
                  data-testid={`menu-${item.title.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  <div className="flex items-start gap-4">
                    <div className={`
                      p-3 rounded-lg
                      ${isFirst 
                        ? 'bg-blue-100' 
                        : isLast
                        ? 'bg-slate-100'
                        : 'bg-slate-100'
                      }
                    `}>
                      <Icon className={`
                        h-6 w-6
                        ${isFirst 
                          ? 'text-blue-700' 
                          : isLast
                          ? 'text-slate-700'
                          : 'text-slate-700'
                        }
                      `} />
                    </div>
                    <div className="flex-1">
                      <h3 className={`
                        text-lg font-semibold mb-1
                        ${isFirst 
                          ? 'text-blue-900' 
                          : 'text-slate-900'
                        }
                      `}>
                        {item.title}
                      </h3>
                      <p className="text-sm text-slate-600">
                        {item.description}
                      </p>
                    </div>
                    <div className="flex items-center">
                      <svg 
                        className={`h-5 w-5 ${isFirst ? 'text-blue-500' : 'text-slate-400'}`}
                        fill="none" 
                        viewBox="0 0 24 24" 
                        stroke="currentColor"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </main>
    </div>
  );
}
